export default function LocalCompanySection() {
  return (
    <section data-testid="local-company-section" className="py-14 md:py-20 px-4 md:px-8 bg-navy">
      <div className="max-w-4xl mx-auto">
        <span className="text-xs uppercase tracking-[0.2em] font-bold text-orange">Express Delivery</span>
        <h2 className="font-heading font-bold text-3xl md:text-4xl tracking-tight text-white mt-3 mb-4">
          Une entreprise locale, un interlocuteur unique
        </h2>
        <p className="text-white/75 text-base leading-relaxed max-w-2xl">
          Basée au Havre, Express Delivery organise chaque prestation directement avec le client, de la première demande jusqu'à la livraison. Vous savez qui intervient, quand et dans quelles conditions.
        </p>
      </div>
    </section>
  );
}
